import cx from 'classnames';
import { ContentImage } from 'govbr.frontend.policy/components';
import { defineMessages, useIntl } from 'react-intl';

import Face from '../Face';
import FlipButton from '../FlipButton';

import styles from './Front.module.less';

const messages = defineMessages({
  showCardDescription: {
    id: 'Show card description',
    defaultMessage: 'Show card description',
  },
  hideCardDescription: {
    id: 'Hide card description',
    defaultMessage: 'Hide card description',
  },
});

const Front = ({
  title,
  subtitle,
  description,
  hideIcons,
  item,
  size = 'md',
  background = 'gray',
  opened,
  handleFlip,
  columns,
  isEditMode,
  primary,
  serviceCard = false,
}) => {
  const icon = hideIcons ? null : item.icone_card;

  const intl = useIntl();

  const classes = cx(
    styles[background],
    styles[size],
    styles[`cols${columns}`],
    {
      [styles.primary]: primary,
      [styles.hasSubtitle]: subtitle && !serviceCard,
      [styles.serviceCard]: serviceCard,
    },
  );

  const contentClasses = cx(styles.content, {
    [styles.serviceContent]: serviceCard,
  });

  const titleClasses = cx(styles.title, 'custom-card-title', {
    [styles.serviceTitle]: serviceCard,
  });

  return (
    <Face className={classes} item={item} isEditMode={isEditMode}>
      {serviceCard && subtitle ? (
        <div className={styles.serviceSubtitle}>{subtitle}</div>
      ) : null}
      {icon && size !== 'sm' ? (
        <div className={styles.iconW}>
          <span className={`${icon} ${styles.icon}`} />
        </div>
      ) : null}

      {hideIcons || size === 'sm' ? null : (
        <ContentImage
          item={item}
          alt={item.alt_card}
          size="tile"
          customField="image_card"
          className={styles.img}
        />
      )}
      <div className={contentClasses}>
        <div className={titleClasses}>{title}</div>
        {!serviceCard && subtitle ? (
          <div className={styles.subtitle}>{subtitle}</div>
        ) : null}
      </div>
      {description ? (
        <div className={styles.trigger}>
          <button
            className="br-button circle small"
            onClick={handleFlip}
            aria-label={intl.formatMessage(
              opened
                ? messages.hideCardDescription
                : messages.showCardDescription,
            )}
          >
            {opened ? (
              <span className="fa-solid fa-angle-up" />
            ) : (
              <span className="fa-solid fa-angle-down" />
            )}
          </button>
        </div>
      ) : null}
      {description && size !== 'sm' ? (
        <FlipButton onClick={handleFlip} className={styles.flip} />
      ) : null}
    </Face>
  );
};

export default Front;
